import ModuleView from "@/components/shieldx/ModuleView";
import { UsersRound } from "lucide-react";

const MATRIX = [
  ["View Assets", "YES", "YES", "YES", "YES", "YES"],
  ["Edit Assets", "YES", "YES", "LIMITED", "NO", "NO"],
  ["Manage Incidents", "YES", "YES", "YES", "YES", "NO"],
  ["Modify Policies", "YES", "YES", "LIMITED", "NO", "NO"],
  ["Emergency Controls", "YES", "LIMITED", "APPROVED", "LIMITED", "NO"],
  ["View Audit", "YES", "YES", "YES", "YES", "YES"],
  ["Modify Audit", "NO", "NO", "NO", "NO", "NO"],
  ["Assign Admin Role", "YES", "POLICY", "NO", "NO", "NO"],
];
const ROLES = ["Super Admin", "Org Admin", "SOC Lead", "SecOps", "Auditor"];
const tone = (v) => v === "YES" ? "text-emerald-400" : v === "NO" ? "text-slate-600" : "text-amber-400";

export default function AccessGovernance() {
  return (
    <ModuleView name="access-governance" icon={UsersRound}>
      <div className="mt-4 rounded-xl border border-slate-800 bg-slate-900/50 p-5" data-testid="permission-matrix">
        <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Permission Matrix (enforced server-side)</p>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-slate-800 text-left font-mono text-[10px] uppercase tracking-wide text-slate-500">
                <th className="py-2 pr-4">Permission</th>
                {ROLES.map((r) => <th key={r} className="px-3 py-2">{r}</th>)}
              </tr>
            </thead>
            <tbody>
              {MATRIX.map((row) => (
                <tr key={row[0]} className="border-b border-slate-800/60">
                  <td className="py-2 pr-4 text-slate-300">{row[0]}</td>
                  {row.slice(1).map((v, i) => <td key={i} className={`px-3 py-2 font-mono font-semibold ${tone(v)}`}>{v}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-[11px] text-slate-500">Phishing-resistant authentication (passkeys/FIDO2) significantly reduces account-takeover risk when correctly configured — not an absolute guarantee.</p>
      </div>
    </ModuleView>
  );
}
